<template>
  <BaseAction :action="action">
    <span>
      Add your location
    </span>
  </BaseAction>
</template>

<script>
import BaseAction from '@/components/candidate/action_items/BaseAction'

// Vue Component
export default {
  components: { BaseAction },
  props: { action: Object },
}
</script>
